import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { PatientService } from '@avanta/shared/services/patients';
import { PsychologistService } from '@avanta/shared/services/psychologists';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { AppointmentService } from 'services/appointments';
import { useEnterpriseId } from 'stores/user';
import { type AppointmentWithDetails } from 'types/appointments';

export const useFetchEnterpriseAppointments = (): UseQueryResult<AppointmentWithDetails[]> => {
  const enterpriseId = useEnterpriseId();

  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_ENTERPRISE_APPOINTMENTS, enterpriseId],
    queryFn: async () => {
      const { data: appointments } =
        await AppointmentService.getEnterpriseAppointments(enterpriseId);

      return Promise.all(
        appointments.map(async appointment => {
          const [psychologist, patient, center] = await Promise.all([
            PsychologistService.getPsychologist(appointment.psychologistId),
            PatientService.getPatient(appointment.patientId),
            AppointmentService.getCenterDetails(appointment.backofficeCenterId),
          ]);

          return {
            ...appointment,
            psychologist: {
              name: psychologist.data.name,
              surname: psychologist.data.surname,
            },
            patient: {
              firstName: patient.data.firstName,
              surname: patient.data.surname,
            },
            center: {
              name: center.data.name,
              city: center.data.city,
            },
          };
        })
      );
    },
    enabled: !!enterpriseId,
  });
};
